module.exports = __webpack_public_path__ + "fonts/montserrat-bold.39d93cf6.woff2";